import { isNumber, isString } from 'lodash-es';
import { redirectToExpired } from 'utilities/error';

export function splitSeconds(seconds) {
  const digits = seconds.toString().split('');
  return digits.map(Number);
}

export function MSToMinutesAndSeconds(MS) {
  const minutes = Math.max(0, Math.floor(MS / 60000));
  const seconds = Math.max(0, Number(((MS % 60000) / 1000).toFixed(0)));
  return {
    minutes,
    seconds
  };
}

export function parseSendOTPResponse(responseData) {
  const sendOTPStatus = responseData.status;
  const sendOTPError = responseData.error;
  return {
    sendOTPError,
    sendOTPStatus
  };
}

export function parseC2CTransferPageAmountCurrency(pageData) {
  const amount = pageData?.amount;
  const currency = pageData?.currency;
  const didProvideAmount =
    (isNumber(amount) || isString(amount)) &&
    (Boolean(amount) || amount === 0 || amount === '0');
  const didProvideCurrency = isString(currency) && Boolean(currency);
  return {
    amount: didProvideAmount ? amount : null,
    currency: didProvideCurrency ? currency : null,
    didProvideAmount,
    didProvideCurrency
  };
}

export const getInitialTargetDate = timer => {
  const { minutes = 3, seconds = 0 } = timer || {};
  const targetDate = new Date();
  targetDate.setSeconds(targetDate.getSeconds() + seconds);
  targetDate.setMinutes(targetDate.getMinutes() + minutes);
  return targetDate.getTime();
};

export const redirectOtpToCompleteOrError = ({
  isPaymentSuccess,
  completePaymentUrl,
  is3DSPending,
  expired,
  errorPaymentUrl
}) => {
  let redirected = false;
  if (isPaymentSuccess && completePaymentUrl) {
    window.location.href = completePaymentUrl;
    redirected = true;
  } else if (!isPaymentSuccess && !is3DSPending && errorPaymentUrl) {
    window.location.href = errorPaymentUrl;
    redirected = true;
  } else if (expired) {
    redirectToExpired();
    redirected = true;
  }
  return redirected;
};
